import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';
import { type UseFormReturn, useWatch } from 'react-hook-form';
import type { CustomQuestionsFormData } from '../types';
import { templateToIdentifier } from '../utils/label-to-identifier';
const suggestFromTitle = (title: string) => {
  const slug = templateToIdentifier(title);
  return slug ? `custom.${slug}` : '';
};

/**
 * Suggests the attribute a page's buttons save to from its title, and keeps following the title
 * until the author edits the field. It runs in the form, not the Buttons section, since that
 * section unmounts while a question holds the panel.
 */
const useAutoChoiceIdentifier = t0 => {
  const $ = _c(10);
  const {
    control,
    setValue,
    getFieldState
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["title", "choice.saveValue", "choice.dataIdentifier"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== control) {
    t2 = {
      control,
      name: t1
    };
    $[1] = control;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const [title, saveValue, dataIdentifier] = useWatch(t2);
  const lastSuggestion = useRef(null);
  const isAuthored = useRef(false);
  let t3;
  let t4;
  if ($[3] !== dataIdentifier || $[4] !== getFieldState || $[5] !== saveValue || $[6] !== setValue || $[7] !== title) {
    t3 = () => {
      const suggestion = suggestFromTitle(title);
      if (lastSuggestion.current === null) {
        isAuthored.current = !!dataIdentifier;
        lastSuggestion.current = dataIdentifier;
      }
      if (isAuthored.current || !saveValue) {
        return;
      }
      if (dataIdentifier === suggestion) {
        lastSuggestion.current = suggestion;
        return;
      }
      if (dataIdentifier !== lastSuggestion.current) {
        isAuthored.current = true;
        return;
      }
      setValue("choice.dataIdentifier", suggestion, {
        shouldDirty: true,
        shouldValidate: !!getFieldState("choice.dataIdentifier").error
      });
      lastSuggestion.current = suggestion;
    };
    t4 = [title, saveValue, dataIdentifier, setValue, getFieldState];
    $[3] = dataIdentifier;
    $[4] = getFieldState;
    $[5] = saveValue;
    $[6] = setValue;
    $[7] = title;
    $[8] = t3;
    $[9] = t4;
  } else {
    t3 = $[8];
    t4 = $[9];
  }
  useEffect(t3, t4);
};
export default useAutoChoiceIdentifier;